<style lang="scss">
.ar-player {
  margin: 0 auto;
  max-width: 539px;
  height: unset;
  border: 0;
  border-radius: 0;
  // display: flex;
  // flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: unset;
  font-family: "Roboto", sans-serif;

  &>.ar-player-bar {
    background:rgb(3, 109, 124);

    &>.ar-player__progress {
      
    }
  }

  &-bar {
    display: flex;
    align-items: center;
    height: 70px;
    padding-left: 25px;
  }

  &-actions {
    align-items: center;
    justify-content: space-around;
    padding-left: 5px;
    margin-left: 5px;
  }

  &__progress {
    width: 100%;
  }

  &__time {
    color: #fff;
    font-size: 16px;
  }

  &__play {
    display: inline-block;
    width:25px;
    height: 25px;
    background-size: contain !important;
    background: url("~@/assets/img/toefl/playing-s.png") center no-repeat;
    &:hover {
      background: url("~@/assets/img/toefl/playing-s-h.png") center no-repeat;
      }
    &--active {
      background: url("~@/assets/img/toefl/playing.png") center no-repeat;

      &:hover {
        background: url("~@/assets/img/toefl/playing-h.png") center no-repeat;
      }
    }

  }
}

.ar-player-bar>div {
  float: left;
}
.bar-s{
  width: 70%;padding-top:10px;
}
.n-bar-s{
  width: 100%;pointer-events: none;
}
.n-ar-player-bar{
  background: none !important;
    height: 30px;
    border: none !important;
    padding-left:0;
}
.player-select .el-input {
  height: 24px;
  width: 50px;
}

.player-select .el-input__inner {
  height: 24px;
  line-height: 24px;
  padding-right: 15px;padding-left: 10px;
  border:none;
  background: none;
  color:#fff;
}
.player-select .el-input__suffix{
  right: 0px !important;
  top:3px;
}
.player-select .el-input .el-select__caret{
  color:#fff
}
.speed-c{
  border-left: 1px solid #fff;
}
</style>

<template>
  <div class="ar-player">
    <div :class="controls?'ar-player-bar':'ar-player-bar n-ar-player-bar'">
      <div :class="controls?'bar-s':'n-bar-s'">
        <line-control class="ar-player__progress" ref-id="progress" :percentage="progress"
          @change-linehead="_onUpdateProgress" />
        <div class="ar-player__time" style="float:left;" v-if="controls">{{ playedTime }}</div>
        <div class="ar-player__time" style="float:right;" v-if="controls">{{ duration }}</div>
      </div>
      <div style="width: 10%" v-if="controls">
        <div class="ar-player-actions">
            <span :class="{ 'ar-player__play--active': !isPlaying, 'ar-player__play': true}" @click="playback"></span>
        </div>
      </div>
      <!-- <div style="width: 8%">
        <div class="ar-player-actions">
          <icon-button id="play" class="ar-icon ar-icon__lg ar-player__play" :name="playBtnIcon"
            :class="{ 'ar-player__play--active': isPlaying }" @click.native="playback" />
        </div>
      </div> -->
      <div style="width: 20%" v-if="controls" class="speed-c">
        <el-select v-model="speed" size="mini" @change="speedChanged" class="player-select">
          <el-option value='0.5'>0.5</el-option>
          <el-option value='0.75'>0.75</el-option>
          <el-option value='1'>1</el-option>
          <el-option value='1.25'>1.25</el-option>
          <el-option value='1.5'>1.5</el-option>
        </el-select>
      </div>
      <!-- <volume-control @change-volume="_onChangeVolume"/> -->
    </div>

    <audio :id="playerUniqId" :src="audioSource" :autoplay="autoplay"></audio>
  </div>
</template>

<script>
import IconButton from "./icon-button";
import LineControl from "./line-control";
import VolumeControl from "./volume-control";
import { convertTimeMMSS } from "@/components/toefl/audio/lib/utils";

export default {
  props: {
    controls: { type: Boolean ,default: true},
    src: { type: String },
    record: { type: Object },
    filename: { type: String },
    autoplay: { type: Boolean },
    playerEnded : { type: Function },
    start : { type: Function },
  },
  data() {
    return {
      isPlaying: false,
      duration: convertTimeMMSS(0),
      playedTime: convertTimeMMSS(0),
      progress: 0,
      speed: 1
    };
  },
  components: {
    IconButton,
    LineControl,
    VolumeControl,
  },
  mounted: function () {
    this.player = document.getElementById(this.playerUniqId);

    this.player.addEventListener("play", () => {
      this.start && this.start()
      this.isPlaying = true;
    });
    this.player.addEventListener("ended", () => {
      this.isPlaying = false;
      this.playerEnded && this.playerEnded()
    });

    this.player.addEventListener("loadeddata", (ev) => {
      this._resetProgress();
      this.duration = convertTimeMMSS(this.player.duration);
    });

    this.player.addEventListener("timeupdate", this._onTimeUpdate);

    this.$eventBus.$on("remove-record", () => {
      this._resetProgress();
    });
  },
  computed: {
    audioSource() {
      const url = this.src || this.record.url;
      if (url) {
        return url;
      } else {
        this._resetProgress();
      }
    },
    playBtnIcon() {
      return this.isPlaying ? "pause" : "play";
    },
    playerUniqId() {
      return `audio-player${this._uid}`;
    },
  },
  methods: {
    playback() {
      if (!this.audioSource) {
        return;
      }

      if (this.isPlaying) {
        this.player.pause();
      } else {
        setTimeout(() => {
          this.player.play();
        }, 0);
      }

      this.isPlaying = !this.isPlaying;
    },
    _resetProgress() {
      if (this.isPlaying) {
        this.player.pause();
      }

      this.duration = convertTimeMMSS(0);
      this.playedTime = convertTimeMMSS(0);
      this.progress = 0;
      this.isPlaying = false;
    },
    _onTimeUpdate() {
      this.playedTime = convertTimeMMSS(this.player.currentTime);
      this.progress = (this.player.currentTime / this.player.duration) * 100;
    },
    _onUpdateProgress(pos) {
      if (pos) {
        this.player.currentTime = pos * this.player.duration;
      }
    },
    _onChangeVolume(val) {
      if (val) {
        this.player.volume = val;
      }
    },
    speedChanged() {
      this.player.playbackRate = this.speed
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/toefl/audio/components/player.vue